export default __webpack_public_path__ + "static/media/programate-academy-color-.337e5d4e.png";